<script>
import {relatorioCertidaoNegativaLeilao2} from "@/domain/leiloes/services"
import RelatorioTemplate from "./RelatorioTemplate"

export default {
  mixins: [RelatorioTemplate],
  nome: 'LeilaoRelatorioCertidaoNegativa2',
  created() {
    this.isLoading = true
    relatorioCertidaoNegativaLeilao2(this.leilao.id)
        .then((response) => {
          this.dados = response.data
          this.isLoading = false
        })
        .catch((response) => {
          // this.isLoading = false
          this.alertApiError(response)
          console.log(response)
        })
  }
}
</script>
